// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4YQKp","toggleWrap":"styles_toggleWrap__3BcaC","content":"styles_content__LSXEu","selectAreaCode":"styles_selectAreaCode__2q9OZ"};